var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FieldContainer',{attrs:{"label":_vm.label,"required":_vm.required,"readOnly":_vm.readOnly,"error":_vm.displayError,"hintHtml":_vm.hintHtml}},[_c('input',{staticClass:"ps-input no-spinner",attrs:{"type":"number","readonly":_vm.readOnly},domProps:{"value":_vm.value},on:{"input":_vm.updateValue,"blur":_vm.onBlur}})])
}
var staticRenderFns = []

export { render, staticRenderFns }